import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { StatusBadge, requestStatus } from "@/components/StatusBadge";
import { sectorStyle } from "@/lib/sectors";

export const RequestRow = ({ r }) => {
  const { svcName, t } = useApp();
  const st = sectorStyle(r.service.sector_id);
  const Icon = st.icon;
  return (
    <Link to={`/requests/${r.ref}`} data-testid={`request-row-${r.ref}`} className="flex items-center gap-3 rounded-xl border border-border/60 bg-card p-3 shadow-sm transition-shadow hover:shadow-md">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg" style={{ background: st.bg, color: st.color }}><Icon size={18} /></span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-semibold">{svcName(r.service)}</span>
        <span className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-muted-foreground">
          <span className="font-mono">{r.ref}</span>
          <StatusBadge status={requestStatus(r)} />
          <span>{t("step")} {r.workflow_step}/7</span>
        </span>
      </span>
      <ChevronRight size={16} className="q1-flip text-muted-foreground" />
    </Link>
  );
};

export default function RequestsPage() {
  const { t, demoUser } = useApp();
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("all");
  useEffect(() => { api.get("/me/requests").then((r) => setItems(r.data)).catch(() => setItems([])); }, [demoUser]);
  const list = (items || []).filter((r) => tab === "all" || (tab === "done" ? r.status === "Completed" : r.status !== "Completed"));
  const tabs = [["all", "All"], ["open", t("inProgress")], ["done", t("completed")]];
  return (
    <div className="space-y-4 px-4 pt-4" data-testid="requests-page">
      <h1 className="text-2xl font-bold">{t("myRequests")}</h1>
      <div className="flex gap-1 rounded-xl bg-muted p-1" role="tablist">
        {tabs.map(([k, label]) => (
          <button key={k} role="tab" aria-selected={tab === k} data-testid={`requests-tab-${k}`} onClick={() => setTab(k)}
            className={`min-h-[40px] flex-1 rounded-lg text-sm font-semibold transition-colors ${tab === k ? "bg-card shadow-sm" : "text-muted-foreground"}`}>
            {label} {items && <span className="text-xs text-muted-foreground">({(items || []).filter((r) => k === "all" || (k === "done" ? r.status === "Completed" : r.status !== "Completed")).length})</span>}
          </button>
        ))}
      </div>
      <div className="space-y-2" data-testid="requests-list">
        {!items && Array.from({ length: 5 }).map((_, i) => <div key={i} className="h-16 animate-pulse rounded-xl bg-muted" />)}
        {items && list.length === 0 && <p className="py-10 text-center text-sm text-muted-foreground">{t("noRequests")}</p>}
        {list.map((r) => <RequestRow key={r.ref} r={r} />)}
      </div>
    </div>
  );
}
